var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBellIcon = function SvgBellIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M9.55 21.5h4.9a2.51 2.51 0 0 1-2.45 2 2.51 2.51 0 0 1-2.45-2ZM21.396 16.854l.147.146h.957c.336 0 .578.11.734.266s.266.398.266.734-.11.578-.266.734-.398.266-.734.266h-21c-.336 0-.578-.11-.734-.266S.5 18.336.5 18s.11-.578.266-.734S1.164 17 1.5 17h.957l.147-.146C3.67 15.786 5 14.16 5 12V7.5c0-3.924 3.076-7 7-7s7 3.076 7 7V12c0 2.161 1.329 3.786 2.396 4.854Z"
  })));
};
export default SvgBellIcon;